<template>
  <v-layout row justify-center>
    <v-dialog v-model="params.show" max-width="600px" persistent>
      <v-form id="newBillPaymentForm">
        <v-card>
          <v-card-title>
            <span class="headline">Novo Pagamento</span>
          </v-card-title>
          <v-card-text>
            <div class="mb-3">
              <h4>Boleto Bancário ou Concessionária</h4>
            </div>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    label="Código de Barras ou Linha Digitável*"
                    v-model="params.bill_payment.digitable_line"
                    persistent-hint
                    hint="Cole o código de barras (44 dígitos) ou linha digitável (47 dígitos)"
                    required
                    :mask="getDigitableLineMask()"
                    :rules="[params.rules.required, params.rules.digitableLineCounter]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Nosso Número"
                    v-model="params.bill_payment.our_number"
                    persistent-hint
                    hint="Campo opcional - será preenchido automaticamente se não informado"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Valor do Boleto*"
                    v-model.lazy="params.bill_payment.bill_amount"
                    v-money="money" 
                    :rules="[params.rules.required, params.rules.amountValidation]"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <h4>Data de Vencimento*</h4>
                  <v-date-picker
                    v-model="params.bill_payment.due_date"
                    locale="pt-br"
                    :landscape="true"
                    :reactive="true"
                    :rules="[params.rules.required]"
                    required
                  ></v-date-picker>
                  <small class="grey--text">A data de vencimento do boleto (o pagamento será processado hoje)</small>
                </v-flex>
                <small>*campos requeridos</small>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="params.show = false">Fechar</v-btn>
            <v-btn
              color="primary"
              :loading="params.loadingButton"
              @click="submitNewBillPayment"
            >Enviar Pagamento</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="params.billDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline success--text">
          <v-icon color="success" class="mr-2">check_circle</v-icon>
          Pagamento Enviado com Sucesso
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="body-1 mb-3">
            Seu pagamento foi enviado para processamento e aparecerá na listagem abaixo.
          </p>
          <p class="body-2 grey--text">
            O status será atualizado automaticamente conforme o processamento. 
            Em caso de inconsistência nos dados, o valor será estornado automaticamente.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="params.billDialog = false">
            <v-icon left>thumb_up</v-icon>
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="params.billDialogErrors" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Erro ao processar pagamento</v-card-title>
        <v-card-text v-if="!erroMessage">
          Erro ao processar seu pagamento. Verifique se a operação está habilitada,
          se você tem saldo na sua conta digital e se todos os campos estão corretos,
          ou entre em contato com a {{ appName }}.
        </v-card-text>
        <v-card-text v-else>{{erroMessage}}</v-card-text>
        <v-card-actions>
          <v-btn
            color="red"
            block
            center
            @click="params.billDialogErrors = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";
import { changed } from '@/helpers/layout';
import { VMoney } from 'v-money';
import { mask } from 'vue-the-mask';
import { moment } from 'moment';

export default {
  name: "NewBillPaymentForm",
  created() {
    EventBus.$on("show-new-bill-payment-form", () => {
      this.params.show = true;
    });
    this.$store.dispatch("system/fetchSystemConfiguration");
  },
  computed: {
    ...mapGetters({
      createdBill: "bills/billPayment",
      billErrors: "bills/billPaymentError",
      systemAppName: "system/appName",
      account: "account/account",
    }),
    appName() {
      return this.systemAppName || process.env.VUE_APP_APP_NAME || 'FlowIt';
    },
    paymentProvider() {
      return (this.account && this.account.bill_source) || 'banco_abc';
    },
  },
  watch: {
    createdBill(newValue, oldValue) {
      this.params.billDialog = true;
      this.params.show = false;
      this.params.loadingButton = false;
      // Atualizar listagem de pagamentos após sucesso
      this.$store.dispatch('bills/loadBillsPayment', this.$store.getters['bills/billsPaymentFilter']);
      // Limpar formulário para novos pagamentos
      this.resetForm();
    },
    billErrors(newValue, oldValue) {
      if (newValue && newValue.errors && newValue.errors.length > 0) {
        this.params.billDialogErrors = true;
        this.params.show = false;
        this.params.loadingButton = false;
        this.erroMessage = newValue.errors[0]['response_code_detail'] || 'Erro desconhecido';
      }
    }
  },
  data: () => ({
    erroMessage: false,
    params: {
      picker: new Date().toISOString().substr(0, 10),
      show: false,
      billDialog: false,
      billDialogErrors: false,
      loadingButton: false,
      bill_payment: {
        digitable_line: "",
        due_date: new Date().toISOString().substr(0, 10),
        our_number: "",
        bill_amount: ""
      },
      rules: {
        required: value => !!value || "Campo obrigatório",
        documentCounter: value => value.length == 14 || "Documento inválido",
        nameCounter: value => value.length <= 30 || "Máximo 30 caracteres",
        digitableLineCounter: value => {
          if (!value) return "Campo obrigatório";
          const cleanValue = value.replace(/[^0-9]/g, ''); // Remove caracteres não numéricos
          return (cleanValue.length === 44 || cleanValue.length === 47) || 
                 "Código inválido - deve ter 44 caracteres (código de barras) ou 47 caracteres (linha digitável)";
        },
        amountValidation: value => {
          if (!value) return "Campo obrigatório";
          const numValue = parseFloat(value.toString().replace(/[^\d,]/g, '').replace(',', '.'));
          return numValue > 0 || "Valor deve ser maior que zero";
        },
      },
    },
    valueRules: [
      v => !!v || 'Valor deve ser válido',
    ],
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    },
  }),
  directives: {money: VMoney, mask},
  methods: {
    submitNewBillPayment() {
      // Validação básica antes do envio
      if (!this.params.bill_payment.digitable_line || 
          !this.params.bill_payment.bill_amount || 
          !this.params.bill_payment.due_date) {
        this.erroMessage = "Por favor, preencha todos os campos obrigatórios";
        this.params.billDialogErrors = true;
        return;
      }

      this.new_params = {
        agency_bill: this.params.bill_payment.agency_bill,
        account_bill: this.params.bill_payment.account_bill,
        bill_amount: parseFloat(this.params.bill_payment.bill_amount.replace(/[^\d]+/g,''))/100 ,
        due_date: this.params.bill_payment.due_date, // Data de vencimento customizável
        our_number: this.params.bill_payment.our_number,
        digitable_line: this.params.bill_payment.digitable_line
      }
      
      const response = this.$store.dispatch(
        "bills/newBillPayment",
        this.new_params
      );
      this.params.loadingButton = true;
    },
    resetForm() {
      this.params.bill_payment = {
        digitable_line: "",
        due_date: new Date().toISOString().substr(0, 10),
        our_number: "",
        bill_amount: ""
      };
    },
    getDigitableLineMask() {
      if (!this.params.bill_payment.digitable_line) {
        return "#####.#####  #####.###### #####.###### # ##############"; // Máscara padrão quando vazio
      }
      
      const cleanValue = this.params.bill_payment.digitable_line.replace(/[^0-9]/g, '');
      
      // Se começa com 8 ou tem até 44 caracteres, é provavelmente código de barras (sem máscara)
      if (cleanValue.length > 0 && (cleanValue.charAt(0) === "8" || cleanValue.length <= 44)) {
        return null; // Remove a máscara para código de barras
      } else {
        return "#####.#####  #####.###### #####.###### # ##############"; // Máscara para linha digitável
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 8px !important;
}

.v-card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white !important;
}

.v-card-title .headline {
  color: white !important;
}

.v-text-field {
  margin-bottom: 8px;
}

.v-btn.primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
}

.v-date-picker {
  border-radius: 8px;
}

.mb-3 h4 {
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
}
</style>
